import styled from "styled-components";

import { ButtonSuccess } from "../../utils/styles";

export const InsertButton = styled(ButtonSuccess)`
  margin-right: 5px;
  padding: 5px;
`;
